import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [

    {
        cameraLocationId: 'ACK_ACK_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Acknowledgements',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'INT_INT_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Welcome',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'MSK_MSK_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'ECCA Moves to St. Kitts after Barbados Withdraws',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'EST_EST_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Establishment of the ECCB',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'EXP_EXP_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Expansion of the ECCB',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'SCJ_SCJ_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Sir Cecil Jacobs, 1st Governor of the ECCB',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'CUR_CUR_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Currency',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
{
        cameraLocationId: 'WAL_WAL_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Sir William Arthur Lewis',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'PEC_PEC_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `ECCB’s Public Education & Communications<br>(A 20-Year Retrospective from 1992 to 2012)`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'LSC_LSC_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `In Studio Camera: ECCB@40 Anniversary Lecture Series`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'LSC_LSC_ZH02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `In Studio Camera: ECCB@40 Anniversary Youth Activities`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'CIN_CIN_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Cineplex',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'LTI_LTI_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Lives and Times of…',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'ASN_ASN_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'ECCB Anniversaries (Selected Notices)',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'LAF_LAF_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Launches and Firsts',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'DVE_DVE_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Sir K. Dwight Venner',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'TVP_TVP_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Viewing Point',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'TBP_TBP_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'The Big Push: Capacity-Building & Collaboration',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'TAN_TAN_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Timothy N.J. Antoine`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'VAN_VAN_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Vacancy Announcements (The First 20 Years)',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'TIM_TIM_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Timeline',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },
    {
        cameraLocationId: 'CAL_CAL_ZH01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'ECCB@40 Calendar of Events',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    },

    {
        cameraLocationId: 'DownStairsLoc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Down Stairs`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        hideFromModal: 'Y',
    },
    {
        cameraLocationId: 'UpStairsLoc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Up Stairs`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        hideFromModal: 'Y',
    }

    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: '',
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    // },
    // {
    //     cameraLocationId: 'W01Z01',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: `Look Under Seat #1`,
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N',
    // },
    // {
    //     cameraLocationId: 'GroundFloorCamLoc',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: `Ground Floor`,
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N',
    //     cameraLocationLevel2Id: ['NANWENG01', 'NANCIDG01', 'NANHDSG01', 'NANHDSG02', 'NANHGSG01', 'NANHGSG01B', 'NANCLOG01', 'VENCORG01', 'VENRESG01', 'NANDEPG01'],
    // },
    // {
    //     cameraLocationId: 'NANWENG01',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: `Welcome to Venice`,
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N',
    //     cameraLocationIdOfChild: 'Y',
    // },

];

export {CameraLocationsDB, FLOOR_NUMBER};
